import { BASE_USER_URL } from 'appConstants';
import { routesMapToRoles } from 'router/routes';

export const getRoutesForRole = role => routesMapToRoles[role] || [];

export const getDefaultRouteForRole = role => getRoutesForRole(role)[0]?.to || BASE_USER_URL;

export const hasRouteChildAccess = (role, routePath, childPath) =>
  getRoutesForRole(role).some(
    route =>
      route.to === routePath && Array.isArray(route.children) && route.children.some(child => child.to === childPath),
  );
